<template>
    <div>
        <h5 v-if="id === null" class="h5 text-primary">New Area</h5>
        <h5 v-else class="h5 text-primary">Editing Area ({{ id }})</h5>
        <div class="row">
            <div class="col-12 col-md-8 col-lg-6 mb-2">
                <input type="text" class="form-control" placeholder="Name" aria-label="Name" aria-describedby="basic-addon2" v-model="name"/>
            </div>
            
            <div class="col-12 col-md-2 col-lg-3 mb-2">
                <select class="form-select" v-model="state">
                    <option v-for="(name, abbr) in states" :value="abbr">{{  name }}</option>
                </select>
            </div>

            <div class="col-12 col-md-2 col-lg-3 mb-2">
                <input type="number" class="form-control" min="1900" :max="maxYear" v-model="year"/>
            </div>

            <cancel-submit-button
                @cancel="cancel()"
                @submit="submit()"
            ></cancel-submit-button>
        </div>
    </div>
</template>

<script>

import CancelSubmitButton from './CancelSubmitButton.vue';

export default {
    components: { CancelSubmitButton },

    props: {
        value: {
            type: Object,
            default: function(data={}) {
                return {};
            },
        },
    },

    computed: {
        maxYear: function() {
            return new Date().getFullYear() + 5;
        },
    },

    data() {
        const states = { 
                'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas', 'CA': 'California',
                'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware', 'DC': 'District of Columbia', 'FL': 'Florida',
                'GA': 'Georgia', 'HI': 'Hawaii', 'ID': 'Idaho', 'IL': 'Illinois', 'IN': 'Indiana',
                'IA': 'Iowa', 'KS': 'Kansas', 'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine',
                'MD': 'Maryland', 'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi',
                'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada', 'NH': 'New Hampshire',
                'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York', 'NC': 'North Carolina', 'ND': 'North Dakota',
                'OH': 'Ohio', 'OK': 'Oklahoma', 'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island',
                'SC': 'South Carolina', 'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah',
                'VT': 'Vermont', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia', 'WI': 'Wisconsin',
                'WY': 'Wyoming'
            };
        return {
            id: this.value.id ?? null,
            name: this.value.name ?? '',
            state: this.value.state ?? 'OH',
            year: this.value.year ?? new Date().getFullYear(),

            states: states,
        }
    },

    methods: {
        submit: function() {
            this.$parent.isLoading = true;
            const data = {
                name: this.name,
                state: this.state,
                year: this.year,
            };

            if (this.id) {
                axios
                    .patch(`/api/admin/areas/${this.id}`, data)
                    .then((response) => {
                        this.$emit('input', response.data);
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        this.$parent.isLoading = false;
                    });
            } else {
                axios
                    .post(`/api/admin/areas`, data)
                    .then((response) => {
                        this.$emit('input', response.data);
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        this.$parent.isLoading = false;
                    });
            }
        },

        cancel: function() {
            this.$emit('cancel');
        },

        clear: function() {
            if (!this.id) {
                this.name = '';
                this.year = new Date().getFullYear();
                this.state = 'OH';
            }
        }
    }
}

</script>